import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { MessageCircle } from "react-feather";
import { BasicMapTitle } from "../../../../../Constants/Constants";
import { FilePlus } from "react-feather";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

//FORM
import CreateNoteForm from "./CreateEmployeeNoteForm";

interface ModalProps {
  EmpNo: string;
}

const CreateNoteModal: React.FC<ModalProps> = ({ EmpNo }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <div className="d-flex justify-content-end">
        <Btn
          color="info"
          onClick={toggle}
          style={{ display: "flex", alignItems: "center", gap: "2px" }}
        >
          <MessageCircle size={16} className="me-1"/>
          Add Remarks / Note
        </Btn>
      </div>

      <Modal size="xl" isOpen={modal} toggle={toggle} backdrop="static" keyboard={false}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Add Remarks / Note</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">Record important remarks or notes to help document updates, observations, or other relevant information about the employee.</P>
          </ModalHeader>
          <CreateNoteForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default CreateNoteModal;
